/**
 * Whether application (structured) employment gaps are admin-verified.
 * Used before allowing CV approval with alignment reconciliation notes.
 */

export function areApplicationGapsVerified({
  employmentReview = null,
  employmentReviewPersisted = false,
  complianceEmploymentHistoryGapRow = null,
}) {
  const hasPersisted = Boolean(employmentReviewPersisted && employmentReview?.id);
  const employmentHistoryExists = hasPersisted
    ? (employmentReview?.segments || []).some((segment) => segment?.type === 'employment')
    : Array.isArray(complianceEmploymentHistoryGapRow?.employment_records)
      && complianceEmploymentHistoryGapRow.employment_records.length > 0;

  if (!employmentHistoryExists) return false;

  if (hasPersisted) {
    if (employmentReview?.status === 'cannot_assess') return false;
    const summary = employmentReview?.top_summary || {};
    const total = Number(summary.gap_segments) || 0;
    const verified = Number(summary.verified_gaps) || 0;
    const missing = Number(summary.missing_gaps) || 0;
    const explained = Number(summary.explained_gaps) || 0;
    const rejected = Number(summary.rejected_gaps) || 0;
    return missing === 0 && explained === 0 && rejected === 0 && total === verified;
  }

  const gapEval = complianceEmploymentHistoryGapRow?.gap_evaluation;
  const gapAnalysisRun = Boolean(complianceEmploymentHistoryGapRow?.gap_analysis_run);
  if (!gapAnalysisRun || !gapEval) return false;
  if (complianceEmploymentHistoryGapRow?.gap_analysis_status === 'failed') return false;

  const pending = Number(gapEval.pending_count) || 0;
  const explained = Number(gapEval.explained_count) || 0;
  const rejected = Number(gapEval.rejected_count) || 0;
  const needsInfo = Number(gapEval.needs_info_count) || 0;
  return Boolean(gapEval.is_complete) && pending === 0 && explained === 0 && rejected === 0 && needsInfo === 0;
}

export function cvApprovalWithNoteBlockedReason({
  alignmentStatus,
  applicationGapsVerified = false,
}) {
  if (alignmentStatus !== 'action_required') return null;
  if (applicationGapsVerified) return null;
  return 'Verify all application employment gaps in Employment History & Gap Review before approving this CV with an alignment note.';
}